import BaseEndpoint from "../endpoints/baseEndpoint";

export default async function getPotensiKerja(version, id) {
    try {
        let token = "";
        try {
            const raw = JSON.parse(localStorage.getItem('authUser'));
            token = raw?.token || raw?.user?.token || "";
        } catch (e) {}
        const tokenQuery = token ? `&token=${encodeURIComponent(token)}` : "";

        const sessionData = await BaseEndpoint.instance().get(
            `/exam/${version}/instruction?id=${id}${tokenQuery}`
        );
        const soalData = await BaseEndpoint.instance().get(
            `/exam/${version}?id=${id}${tokenQuery}`
        );

        let sessions = [];

        let timer = sessionData.data?.timer;
        while (typeof timer === "string") {
            try { timer = JSON.parse(timer); } catch (e) { break; }
        }
        if (!timer || typeof timer !== "object") timer = {};

        const instruksiSec = Number(timer.instruksi ?? timer.instruction ?? 65);
        const inkolomSec = Number(timer.inkolom ?? timer.ujian ?? timer.exam ?? 125);
        const changekolomSec = Number(timer.changekolom ?? timer.break ?? 5);

        sessions.push({
            name: "Potensi Kerja",
            type: "instruction",
            content: sessionData.data?.instruksi || "<p>Silakan baca petunjuk pengerjaan dengan seksama sebelum memulai.</p>",
            duration: (instruksiSec > 0 ? instruksiSec : 65) * 1000,
        });

        // Group questions by column
        let soal = [];
        const rawSoal = Array.isArray(soalData.data) ? soalData.data : [];
        rawSoal.forEach((itm, idx) => {
            let currentColumn = parseInt(itm.kolom) - 1;
            if (isNaN(currentColumn) || currentColumn < 0) currentColumn = 0;

            if (soal[currentColumn] === undefined) {
                soal[currentColumn] = [];
            }

            soal[currentColumn].push(itm);
        });

        // Add exam sessions with breaks between columns (not before first column)
        let currentColumn = 0;
        soal.forEach((itm, idx) => {
            // Add break BETWEEN columns (not before first column)
            if (idx !== 0) {
                sessions.push({
                    name: "Potensi Kerja",
                    type: "break",
                    duration: (changekolomSec > 0 ? changekolomSec : 5) * 1000,
                });

                currentColumn = idx;
            }

            sessions.push({
                name: "Potensi Kerja",
                type: "exam",
                content: itm,
                duration: (inkolomSec > 0 ? inkolomSec : 125) * 1000,
            });
        });

        return sessions;
    } catch (error) {
        console.error('Error loading Potensi Kerja session:', error);
        return [];
    }
}
